/* Dr. Thrower's Skincare — theme JS (ported from SFCC head markup, Shopify-adapted:
   no Experience Builder re-scan timers needed; DOM is server-rendered by Liquid). */
(function () {
  'use strict';

  /* ===== Scroll reveals + muted-video autoplay ===== */
  function initReveals() {
    var els = document.querySelectorAll('[data-reveal]:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ===== Parallax backgrounds ===== */
  function initParallax() {
    var ticking = false;
    function update() {
      var els = document.querySelectorAll('[data-parallax]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i], host = el.parentElement, r = host.getBoundingClientRect();
        if (r.bottom < -300 || r.top > window.innerHeight + 300) continue;
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
        var offset = -(((r.top + r.height / 2) - window.innerHeight / 2) * speed);
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      }
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ===== Announcement banner slider ===== */
  function initBanners() {
    document.querySelectorAll('[data-dts-banner]').forEach(function (banner) {
      var viewport = banner.querySelector('[data-dts-viewport]');
      var slides = Array.prototype.slice.call(banner.querySelectorAll('[data-dts-slide]'));
      var prev = banner.querySelector('[data-dts-prev]');
      var next = banner.querySelector('[data-dts-next]');
      if (!viewport || slides.length < 2) return;
      var current = 0, animating = false, autoplayMs = 5000, timer;

      /* The slides are absolutely positioned, so the viewport needs an explicit
         height. This used to run once at init - before webfonts loaded and
         before the viewport had its real width - so the slides measured as if
         wrapped over several lines and the bar froze at ~126px instead of ~17px,
         leaving about 108px of dead colour at the top of every page.

         Two changes: release the previously-set height before measuring (a stale
         value otherwise constrains the measurement), and re-measure whenever the
         result could change - fonts arriving, window resize, full load. */
      function syncHeight() {
        viewport.style.height = 'auto';
        var maxH = 0;
        slides.forEach(function (s) {
          var prevStyle = s.style.cssText;
          s.style.position = 'static'; s.style.transform = 'none';
          s.style.opacity = '1'; s.style.visibility = 'hidden'; s.style.height = 'auto';
          maxH = Math.max(maxH, s.offsetHeight);
          s.style.cssText = prevStyle;
        });
        viewport.style.height = maxH + 'px';
        /* Published so full-height sections can subtract the bar without
           hard-coding a height that depends on this text. */
        document.documentElement.style.setProperty('--dt-banner-h', banner.offsetHeight + 'px');
      }
      var syncTimer;
      function syncHeightSoon() { clearTimeout(syncTimer); syncTimer = setTimeout(syncHeight, 100); }
      window.addEventListener('load', syncHeight);
      window.addEventListener('resize', syncHeightSoon, { passive: true });
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(syncHeight); }
      function show(t) {
        if (animating || t === current) return;
        animating = true;
        var out = slides[current], inc = slides[t];
        out.classList.remove('is-active'); out.classList.add('is-leaving'); out.setAttribute('aria-hidden', 'true');
        inc.classList.add('is-active'); inc.removeAttribute('aria-hidden');
        var done = false;
        var finish = function () {
          if (done) return; done = true;
          out.removeEventListener('transitionend', finish);
          out.classList.remove('is-leaving');
          current = t; animating = false;
        };
        out.addEventListener('transitionend', finish);
        setTimeout(finish, 800);
      }
      function nextSlide() { show((current + 1) % slides.length); }
      function prevSlide() { show((current - 1 + slides.length) % slides.length); }
      function start() { stop(); timer = setInterval(nextSlide, autoplayMs); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      if (next) next.addEventListener('click', function () { nextSlide(); start(); });
      if (prev) prev.addEventListener('click', function () { prevSlide(); start(); });
      banner.addEventListener('mouseenter', stop);
      banner.addEventListener('mouseleave', start);
      window.addEventListener('resize', syncHeight);
      syncHeight();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncHeight);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
    });
  }

  /* ===== Reels carousel ===== */
  function initReels() {
    document.querySelectorAll('.dt-reels').forEach(function (reels) {
      if (reels.__dtInit) return; reels.__dtInit = true;
      var track = reels.querySelector('.dt-reels__track');
      var reals = Array.prototype.slice.call(track.children);
      var N = reals.length; if (!N) return;
      var frontClones = reals.map(function (c) { var k = c.cloneNode(true); k.setAttribute('data-clone', '1'); return k; });
      for (var i = frontClones.length - 1; i >= 0; i--) track.insertBefore(frontClones[i], track.firstChild);
      reals.forEach(function (c) { var k = c.cloneNode(true); k.setAttribute('data-clone', '1'); track.appendChild(k); });
      var all = Array.prototype.slice.call(track.children);
      var pos = N + Math.floor(N / 2);
      var unmuted = false, timer = null, dur = 640;
      var dotsWrap = reels.parentElement.querySelector('.dt-reels__dots');
      var dots = [];
      if (dotsWrap) {
        reals.forEach(function (_, i) {
          var d = document.createElement('button'); d.type = 'button'; d.className = 'dt-reels__dot';
          d.addEventListener('click', function () { jumpTo(i); restart(); });
          dotsWrap.appendChild(d); dots.push(d);
        });
      }
      function realIndex() { return ((pos - N) % N + N) % N; }
      function centerNow(anim) {
        var c = all[pos], off = reels.clientWidth / 2 - (c.offsetLeft + c.offsetWidth / 2);
        if (anim) { track.style.transition = ''; track.style.transform = 'translateX(' + off + 'px)'; }
        else { track.style.transition = 'none'; track.style.transform = 'translateX(' + off + 'px)'; void track.offsetWidth; track.style.transition = ''; }
      }
      function activate(withPlay) {
        all.forEach(function (c) {
          var a = (c === all[pos]), v = c.querySelector('video');
          c.classList.toggle('is-active', a);
          if (!v) return;
          if (a) {
            if (withPlay) { v.muted = !unmuted; c.classList.toggle('is-unmuted', unmuted); c.classList.add('is-playing'); var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); }
          } else { if (v.pause) v.pause(); try { v.currentTime = 0; } catch (e) {} v.muted = true; c.classList.remove('is-playing', 'is-unmuted'); }
        });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === realIndex()); });
      }
      function normalize() { var np = pos; while (np < N) np += N; while (np >= 2 * N) np -= N; if (np !== pos) { pos = np; centerNow(false); } }
      function next() { pos += 1; activate(false); centerNow(true); window.setTimeout(function () { normalize(); activate(true); }, dur); }
      function jumpTo(i) { pos = N + i; centerNow(false); activate(true); }
      function start() { timer = window.setInterval(next, parseInt(reels.getAttribute('data-autoplay'), 10) || 6500); }
      function stop() { window.clearInterval(timer); }
      function restart() { stop(); start(); }
      // Autoplay is suppressed while the viewer has sound on, so a video they
      // chose to listen to isn't yanked away mid-sentence.
      function autoStart() { if (!unmuted) start(); }

      var didDrag = false;

      reals.forEach(function (c) {
        var v = c.querySelector('video');
        c.addEventListener('click', function (e) {
          if (e.target.closest('.dt-reel__btn')) return;
          if (didDrag) return;                       // a drag, not a tap
          jumpTo(reals.indexOf(c)); restart();
        });
        var pp = c.querySelector('[data-action="playpause"]'), mt = c.querySelector('[data-action="mute"]');
        if (pp) pp.addEventListener('click', function (e) { e.stopPropagation(); if (v.paused) { v.play(); c.classList.add('is-playing'); autoStart(); } else { v.pause(); c.classList.remove('is-playing'); stop(); } });
        if (mt) mt.addEventListener('click', function (e) {
          e.stopPropagation();
          unmuted = !unmuted; v.muted = !unmuted;
          c.classList.toggle('is-unmuted', unmuted);
          if (unmuted) stop(); else restart();
        });
      });

      /* ---- click-drag (desktop) / swipe (touch) ---------------------------
         Pointer Events cover mouse + touch + pen in one path. touch-action
         pan-y keeps vertical page scrolling working while we claim the
         horizontal axis. On release we snap to the nearest slide. */
      var drag = null;
      function baseOffset() { var c = all[pos]; return reels.clientWidth / 2 - (c.offsetLeft + c.offsetWidth / 2); }
      track.style.touchAction = 'pan-y';

      track.addEventListener('pointerdown', function (e) {
        if (e.target.closest('.dt-reel__btn')) return;
        didDrag = false;
        drag = { x: e.clientX, base: baseOffset(), moved: 0 };
        stop();
        track.style.transition = 'none';
        if (track.setPointerCapture) { try { track.setPointerCapture(e.pointerId); } catch (err) {} }
      });

      track.addEventListener('pointermove', function (e) {
        if (!drag) return;
        drag.moved = e.clientX - drag.x;
        if (Math.abs(drag.moved) > 6) didDrag = true;
        track.style.transform = 'translateX(' + (drag.base + drag.moved) + 'px)';
      });

      function endDrag() {
        if (!drag) return;
        var moved = drag.moved;
        drag = null;
        track.style.transition = '';

        var slideW = all[pos].offsetWidth + 20;               // card + track gap
        var steps = Math.round(-moved / slideW);
        var maxSteps = Math.max(N - 1, 1);                    // stay inside the clone buffer
        if (steps > maxSteps) steps = maxSteps;
        if (steps < -maxSteps) steps = -maxSteps;

        pos += steps;
        activate(false);
        centerNow(true);
        window.setTimeout(function () { normalize(); activate(true); }, dur);
        autoStart();
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      window.addEventListener('resize', function () { centerNow(false); });
      centerNow(false); activate(true); start();
    });
  }

  /* ===== Header: search expand + mobile drawer ===== */
  function initNav() {
    document.querySelectorAll('.dt-header').forEach(function (nav) {
      if (nav.__navInit) return; nav.__navInit = true;
      var stog = nav.querySelector('.dt-search-toggle'), sform = nav.querySelector('.dt-search'), sinput = nav.querySelector('.dt-search-input');
      if (stog && sform) stog.addEventListener('click', function (e) { e.preventDefault(); var o = sform.classList.toggle('is-search-open'); if (o && sinput) window.setTimeout(function () { sinput.focus(); }, 60); });
      if (sform) sform.addEventListener('submit', function (e) { e.preventDefault(); var q = sinput ? sinput.value.trim() : ''; if (q) window.location.href = '/search?q=' + encodeURIComponent(q); });
      var burger = nav.querySelector('.dt-burger'), drawer = nav.querySelector('.dt-drawer');
      if (burger && drawer) {
        burger.addEventListener('click', function () { drawer.classList.toggle('hidden'); });
        drawer.addEventListener('click', function (e) { if (e.target === drawer) drawer.classList.add('hidden'); });
        var close = drawer.querySelector('.dt-drawer__close');
        if (close) close.addEventListener('click', function () { drawer.classList.add('hidden'); });
      }
    });
  }

  /* ===== Reveal safety net =====
     [data-reveal] starts at opacity:0 and is only made visible when the
     IntersectionObserver fires. That is fine for a human scrolling, but it
     fails open-loop in several real situations: full-page screenshot tools
     that scroll faster than the observer callbacks, printing, reduced-motion
     edge cases, and any JS error earlier in this file. In every one of those
     the section renders perfectly and is simply invisible, which reads as a
     broken page. Nothing here should ever be able to stay hidden. */
  function revealAll() {
    var els = document.querySelectorAll('[data-reveal]:not(.in)');
    for (var i = 0; i < els.length; i++) els[i].classList.add('in');
  }


  /* ===== Featured products: variant pills + quantity stepper =====
     The card posts to Shopify's own /cart/add, so all this does is keep the
     hidden variant id (and the displayed price) in step with the chosen size,
     and drive the +/- stepper. No cart state is reimplemented here. */
  function initProductCards() {
    document.querySelectorAll('[data-dt-atc]').forEach(function (form) {
      if (form.__dtAtc) return; form.__dtAtc = true;

      var input = form.querySelector('[data-variant-input]');
      var card  = form.closest('.dt-fp__card');
      var price = card && card.querySelector('[data-price-target]');

      form.querySelectorAll('.dt-fp__size').forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.disabled) return;
          form.querySelectorAll('.dt-fp__size').forEach(function (o) { o.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          if (input) input.value = pill.getAttribute('data-variant-id');
          var pv = pill.getAttribute('data-price');
          if (price && pv) price.textContent = pv;
        });
      });
    });
  }

  function run() { initReveals(); initParallax(); initBanners(); initReels(); initNav(); initProductCards(); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);

  window.setTimeout(revealAll, 3000);
  window.addEventListener('load', function () { window.setTimeout(revealAll, 1200); });
  window.addEventListener('beforeprint', revealAll);

  /* Theme editor: re-init when a section is re-rendered, and never leave a
     freshly injected section sitting at zero opacity. */
  document.addEventListener('shopify:section:load', function () { run(); window.setTimeout(revealAll, 600); });
})();
